import i18n from '@/i18n';

const t = i18n.t.bind(i18n);

/** 运行策略说明文案（与云主机 / 下单 Legacy 一致） */
export const RUN_POLICY_DESCRIPTIONS: Record<string, string> = {
  Always: t('common:always.keep.running.even.if.manually.stopped.it.will.automatically.restart'),
  RerunOnFailure: t('common:if.running.fails.it.will.automatically.try.to.restart'),
  Halted: t('common:will.remain.closed.after.startup.unless.manually.started'),
  Manual: t('common:requires.manual.control.of.startup.and.shutdown'),
  Once: t('common:only.starts.once.will.not.automatically.restart.after.stopping.or.crashing'),
};

export function getRunPolicyDescription(value: string): string | undefined {
  return RUN_POLICY_DESCRIPTIONS[value];
}
